// 1:1 aus webapp/projects/club-offering/src/environment.base.ts.
//
// Dort ist ALLES Weitere auskommentiert — kein titleSuffix, kein privacyUrl, kein
// platformOrganization, kein firebase, kein organization/federationIds, kein pushChannelName,
// keine Logo-Dateinamen. Wer diese Felder aus einer anderen App abschreibt, baut Verhalten ein,
// das Angular hier nicht hat (APP_MIGRATE.md §7 „environment.base.ts → config.ts").
export const APP_CONFIG = {
    appId: 'club_offering',
    appType: 'end_user',
    institutionType: 'club',
    apiPath: '/apis/club-offering',
    appVersion: '15.0.0',
    sentryEnvironment: 'club-offering',
} as const;
